class BottomPrice {
	constructor(el) {
		this.container = el;

		if (!this.container) return;

		this.init();
	}

	init() {
		this.cartGroup = this.container.querySelector('[data-cart-buttons]');
		this.cartButton = this.container.querySelector('[data-cart-button]');
		this.productCounter = this.container.querySelector('[data-cart-counter]');

		if (!this.cartGroup || !this.cartButton || !this.productCounter) return;

		this.bindEvents();
	}

	bindEvents() {
		this.cartButton.addEventListener('click', () => this.handleAddToCart());
	}

	handleAddToCart() {
		this.productCounter.classList.add('_active');
		this.cartButton.classList.add('_active');
	}
}

document.querySelectorAll('[data-bottom-price]').forEach((el) => new BottomPrice(el));

export default BottomPrice;
